<template>
  <validation-observer ref="determinationRef" v-slot="{}" tag="form">
    <div class="bg-secondary-13 p-2 rounded">
      <icon-view
        class="mt-2"
        :icon="`mb-1 fas fa-${sectionIcon}`"
        icon-background="#fff"
        icon-color="#FB7058"
        icon-size="18px"
        :title="sectionTitle"
      />
      <div class="row px-5 my-3">
        <div class="col-12">
          <label class="color-gray-6 font-14">Razón:</label>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="model.reason"
              custom-error-msg="La razón es requerida."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="reasons"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div class="col-12 mt-3">
          <label class="color-gray-6 font-14">Comentario:</label>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-text-area
              v-model="model.comment"
              :count-classes="['float-right']"
              custom-error-msg="El comentario es requerido."
              :error="errors[0]"
              :maxlength="3000"
              show-char-count
            />
          </validation-provider>
        </div>
        <div class="col-12 mt-3 d-flex justify-content-end align-items-center">
          <action-button
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger m-2 px-4"
            @click="onCancelHandler"
          />
          <action-button
            i="fas fa-save"
            text="Guardar"
            variant="success px-4"
            @click="onSaveHandler"
          />
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import IconView from 'icon-view';
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import biddingRequestStatus from '@/utils/constants/biddingRequestStatus.js';
import {
  getRequestDeterminationReasons as _getRequestDeterminationReasons,
  saveRequestDetermination as _saveRequestDetermination,
} from '@/services/provider/provider-bidding.api.js';
import providerContractDocumentStatus from '@/utils/constants/providerContractDocumentStatus.js';

export default {
  name: 'BiddingRequestDetermination',
  mixins: [alertMixin],
  components: {
    ValidationObserver,
    ValidationProvider,
    IconView,
    CustomDropDown,
    CustomTextArea,
    ActionButton,
  },
  props: {
    academicYearId: {
      type: Number,
      default: () => null,
    },
    companyId: {
      type: Number,
      default: () => null,
    },
    statusId: {
      type: Number,
      default: () => null,
    },
    contractsDocuments: {
      type: Array,
      default: () => null,
    },
  },
  data: () => ({
    model: {
      reason: null,
      comment: null,
    },
    reasons: [],
  }),
  watch: {
    statusId: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          if (newVal) {
            this.model = {};
            await this.getRequestDeterminationReasons(newVal);
          }
        }
      },
    },
  },
  computed: {
    isForApproved() {
      return this.statusId === biddingRequestStatus.Approved;
    },
    sectionIcon() {
      return this.isForApproved ? 'check' : 'times-circle';
    },
    sectionTitle() {
      return this.isForApproved
        ? 'Información de Aprobación'
        : 'Información de Denegar';
    },
  },
  methods: {
    async getRequestDeterminationReasons() {
      this.reasons = (
        await _getRequestDeterminationReasons(this.statusId)
      ).data;
    },
    onCancelHandler() {
      this.$emit('on-cancel');
    },
    async onSaveHandler() {
      const isValid = await this.$refs.determinationRef.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      const notApplyDocuments = this.contractsDocuments.filter(
        (x) =>
          x.isExempted &&
          x.statusId === providerContractDocumentStatus.Denied &&
          x.documentId
      );

      if (notApplyDocuments && notApplyDocuments.length > 0) {
        this.ShowToast('Alerta', 'Existen documentos que no aplican', 'error');
        return;
      }

      const statuses = {
        [biddingRequestStatus.Approved]: 'Aprobar',
        [biddingRequestStatus.Denied]: 'Denegar',
      };

      const answer = await this.ShowCancelModal(
        'Determinación',
        `¿Está seguro(a) que desea ${statuses[this.statusId]} la solicitud?`,
        'Sí',
        'No'
      );

      if (answer) {
        const payload = {
          academicYearId: +this.academicYearId,
          companyId: +this.companyId,
          statusId: this.statusId,
          reasonId: this.model.reason?.id,
          comment: this.model.comment,
        };

        const { data: result } = await _saveRequestDetermination(payload).catch(
          (err) => {
            this.ShowToast(
              'Alerta',
              err.response.data.message || 'error',
              'error'
            );
          }
        );

        if (result) {
          this.ShowToast(
            'Proceso Exitoso',
            'La solicitud ha sido determinada exitosamente.',
            'success'
          );
          this.$emit('on-saved');
        }
      }
    },
  },
};
</script>
